/* The document named by its UBL type code, followed by one chip per scenario flag.
 *
 * Input:  the row's `typeCode` (null on a received document the hub could not read),
 *         its `flags` (a subset of b2c, export, import_goods, profit_margin, rcm) and direction.
 * Output: "Credit note"; "Invoice" + chips "B2C" "Export"; "Supplier credit note" when received;
 *         "—" and no chip when the type code is null.
 */

import { useTranslation } from "react-i18next";
import "../../i18n";
import { typeCodeLabel } from "../../domain/families";
import { localizedRecord } from "../../i18n/localized";
import styles from "./DocumentsQueue.module.css";

/** Flag keys as HUB-F08 emits them (R7), in sentence case; an unknown key is shown as itself. */
export const FLAG_LABEL: Record<string, string> = localizedRecord("domain.flag", {
  b2c: "B2C",
  export: "Export",
  import_goods: "Import goods",
  profit_margin: "Profit margin",
  rcm: "RCM",
});

export function DocTypeCell({
  typeCode,
  flags,
  direction,
}: {
  typeCode: string | null;
  flags: string[];
  direction: "in" | "out";
}) {
  const { t } = useTranslation();
  const label = typeCodeLabel(typeCode, direction);
  return (
    <span className="row-tight" aria-label={t("documents.docTypeCell.typeAriaLabel", "Type {{label}}", { label })}>
      <span>{label}</span>
      {flags.map((flag) => (
        <span key={flag} className={styles.flagChip}>
          {FLAG_LABEL[flag] ?? flag}
        </span>
      ))}
    </span>
  );
}
